import { withI18n } from 'react-i18next';
import MobileFilterMenu from './MobileFilterMenu';

export const pureComponent = MobileFilterMenu;
export default withI18n()(MobileFilterMenu);
